import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const TOGGLES = [
  ["uploadsOpen", "Recibir leones", "Permite subir o cambiar fotos"],
  ["votingOpen", "Votación abierta", "Permite votar y cambiar votos"],
  ["showResults", "Mostrar resultados a todos", "Si lo apagas, solo tú ves el ranking"],
];

const DelBtn = ({ onConfirm, id }) => {
  const [sure, setSure] = useState(false);
  const click = () => {
    if (!sure) {
      setSure(true);
      setTimeout(() => setSure(false), 3500);
      return;
    }
    onConfirm();
  };
  return <button type="button" className={`del${sure ? " sure" : ""}`} onClick={click} data-testid={`admin-remove-${id}`}>{sure ? "¿Seguro?" : "Quitar"}</button>;
};

export const Admin = ({ data, email, refresh }) => {
  const [busy, setBusy] = useState(false);
  const c0 = data.config, rows = data.results || [], contacts = data.contacts || {};
  const cfg = { uploadsOpen: c0.uploadsSwitch, votingOpen: c0.votingSwitch, showResults: c0.showResults };

  const toggle = async (k) => {
    setBusy(true);
    try { await api.setConfig({ email, ...cfg, [k]: !cfg[k] }); await refresh(); }
    catch (e) { toast(errMsg(e)); } finally { setBusy(false); }
  };
  const remove = async (id) => {
    try { await api.removeEntry(id, email); toast("Participación quitada."); refresh(); }
    catch (e) { toast(errMsg(e)); }
  };
  const copy = async () => {
    const q = (v) => '"' + String(v ?? "").replace(/"/g, '""') + '"';
    const out = [["Lugar", "Nombre", "León", "Correo", "Celular", "Puntos", "1º", "2º", "3º"].map(q).join(",")];
    rows.forEach((e, i) => { const c = contacts[e.id] || {}; out.push([i + 1, e.name, e.lionName, c.email, c.phone, e.pts, e.first, e.second, e.third].map(q).join(",")); });
    const text = out.join("\n");
    try { await navigator.clipboard.writeText(text); toast("Lista copiada. Pégala en Excel."); return; } catch (_) {}
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    toast(ok ? "Lista copiada. Pégala en Excel." : "No se pudo copiar en este navegador.");
  };

  return (
    <section className="on" data-testid="admin-section">
      <h2>Panel del organizador</h2>
      <p className="hint">Solo tú ves esta pestaña.</p>
      <div className="banner" data-testid="admin-deadline-note">
        Cierres automáticos (hora CDMX), aunque los interruptores estén encendidos: subir leones {c0.uploadDeadlinePassed ? "cerró" : "cierra"} el jueves 5 de noviembre a las 12:00; la votación {c0.deadlinePassed ? "cerró" : "cierra"} el viernes 6 de noviembre a las 12:00.
      </div>
      <div className="adm">
        {TOGGLES.map(([k, t, d]) => (
          <div className="tog" key={k}>
            <div><b>{t}</b><div className="tdesc">{d}</div></div>
            <button className={`sw${cfg[k] ? " on" : ""}`} aria-label={t} aria-pressed={cfg[k]} disabled={busy}
              onClick={() => toggle(k)} data-testid={`admin-toggle-${k}`} />
          </div>
        ))}
      </div>
      <div className="adm">
        <div className="admhead">
          <b>Participantes y contacto</b>
          <button className="btn ghost sm" type="button" onClick={copy} data-testid="admin-copy-list-btn">Copiar lista</button>
        </div>
        <div className="tablewrap">
          <table data-testid="admin-participants-table">
            <thead><tr><th>#</th><th>Nombre</th><th>Correo</th><th>Celular</th><th>Pts</th><th></th></tr></thead>
            <tbody>
              {!rows.length && <tr><td colSpan={6}>Sin participantes todavía.</td></tr>}
              {rows.map((e, i) => {
                const c = contacts[e.id] || {};
                return (
                  <tr key={e.id} data-testid={`admin-row-${e.id}`}>
                    <td>{i + 1}</td><td>{e.name}</td><td>{c.email || "—"}</td><td>{c.phone || "—"}</td><td>{e.pts}</td>
                    <td><DelBtn id={e.id} onConfirm={() => remove(e.id)} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
